'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvoiceItem = exports.InvoicePrice = exports.ChildText = exports.Text = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _theme = require('web-makeup/dist/design-system/config/data/theme');

var _style = require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};
var Text = exports.Text = _styledComponents2.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-style: ", ";\n  float: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  margin: ", ";\n  padding: ", ";\n  line-height: ", ";\n  text-align: ", ";\n  display: ", ";\n  width: ", ";\n"], ["\n  font-style: ", ";\n  float: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  margin: ", ";\n  padding: ", ";\n  line-height: ", ";\n  text-align: ", ";\n  display: ", ";\n  width: ", ";\n"])), function (_a) {
    var fontStyle = _a.fontStyle;
    return "" + (fontStyle || 'normal');
}, function (_a) {
    var float = _a.float;
    return "" + (float || 'unset');
}, function (_a) {
    var overflow = _a.overflow;
    return "" + (overflow || 'auto');
}, function (_a) {
    var textOverflow = _a.textOverflow;
    return "" + (textOverflow || 'unset');
}, function (_a) {
    var height = _a.height;
    return "" + (height || 'auto');
}, function (_a) {
    var color = _a.color;
    return "" + (color || 'inherit');
}, function (_a) {
    var verticalAlign = _a.verticalAlign;
    return "" + (verticalAlign || 'unset');
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return "" + (fontWeight || 'normal');
}, function (_a) {
    var size = _a.size;
    return "" + (size || '1rem');
}, function (_a) {
    var margin = _a.margin;
    return "" + (margin || '0');
}, function (_a) {
    var padding = _a.padding;
    return "" + (padding || '0');
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return "" + (lineHeight || 'inherit');
}, function (_a) {
    var textAlign = _a.textAlign;
    return "" + (textAlign || 'justify');
}, function (_a) {
    var display = _a.display;
    return "" + (display || 'block');
}, function (_a) {
    var width = _a.width;
    return "" + (width || 'auto');
});
var ChildText = exports.ChildText = _styledComponents2.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &&& {\n    font-style: ", ";\n    float: ", ";\n    overflow: ", ";\n    text-overflow: ", ";\n    height: ", ";\n    color: ", ";\n    vertical-align: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    margin: ", ";\n    padding: ", ";\n    line-height: ", ";\n    text-align: ", ";\n    display: ", ";\n  }\n"], ["\n  &&& {\n    font-style: ", ";\n    float: ", ";\n    overflow: ", ";\n    text-overflow: ", ";\n    height: ", ";\n    color: ", ";\n    vertical-align: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    margin: ", ";\n    padding: ", ";\n    line-height: ", ";\n    text-align: ", ";\n    display: ", ";\n  }\n"])), function (_a) {
    var fontStyle = _a.fontStyle;
    return "" + (fontStyle || 'normal');
}, function (_a) {
    var float = _a.float;
    return "" + (float || 'unset');
}, function (_a) {
    var overflow = _a.overflow;
    return "" + (overflow || 'auto');
}, function (_a) {
    var textOverflow = _a.textOverflow;
    return "" + (textOverflow || 'unset');
}, function (_a) {
    var height = _a.height;
    return "" + (height || 'auto');
}, function (_a) {
    var color = _a.color;
    return "" + (color || 'inherit');
}, function (_a) {
    var verticalAlign = _a.verticalAlign;
    return "" + (verticalAlign || 'unset');
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return "" + (fontWeight || 'normal');
}, function (_a) {
    var size = _a.size;
    return "" + (size || '1rem');
}, function (props) {
    return "" + (props.margin || '0');
}, function (_a) {
    var padding = _a.padding;
    return "" + (padding || '0');
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return "" + (lineHeight || 'inherit');
}, function (_a) {
    var textAlign = _a.textAlign;
    return "" + (textAlign || 'justify');
}, function (_a) {
    var display = _a.display;
    return "" + (display || 'block');
});
var InvoicePrice = exports.InvoicePrice = function InvoicePrice(_a) {
    var _b = _a.price,
        amount = _b.amount,
        symbol = _b.currency.symbol,
        fontSize = _a.fontSize;
    return React.createElement(ChildText, { width: "200px", fontWeight: "900", size: fontSize || '14px', color: _theme.colors.black1 }, symbol + " " + amount.toLocaleString());
};
var InvoiceItem = exports.InvoiceItem = _styledComponents2.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 0.75rem;\n  line-height: 14px;\n  color: ", ";\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 0.75rem;\n  line-height: 14px;\n  color: ", ";\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])), _style.COLOR_DAWN);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=TextComponents.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/TextComponents.js
// module id = 448
// module chunks = 0